import { createAsyncThunk } from '@reduxjs/toolkit';
import { Contact } from '@/types/contact';
import { RootState } from '../../store';
import { CACHE_DURATION } from './types';
import { contactService } from '@/api/services/contactService';
import { customerService } from '@/api/services/customerService';

export const fetchContacts = createAsyncThunk(
  'contacts/fetchContacts',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      console.log('Fetching all contacts in thunk');
      const response = await contactService.fetchAllContacts();
      console.log('All contacts service response:', response);
      return response.data || [];
    } catch (error: any) {
      console.error('Error in fetchContacts thunk:', error);
      return rejectWithValue(error.message || 'Failed to fetch contacts');
    }
  }
);

export const fetchCustomers = createAsyncThunk(
  'contacts/fetchCustomers',
  async (_, { getState, rejectWithValue }) => {
    try {
      console.log('Fetching customers in thunk');
      const response = await contactService.fetchCustomers();
      console.log('Customer service response:', response);
      return response.data || [];
    } catch (error: any) {
      console.error('Error in fetchCustomers thunk:', error);
      return rejectWithValue(error.message || 'Failed to fetch customers');
    }
  }
);

export const fetchVisitors = createAsyncThunk(
  'contacts/fetchVisitors',
  async (_, { getState, rejectWithValue }) => {
    try {
      console.log('Fetching visitors in thunk');
      const response = await contactService.fetchVisitors();
      console.log('Visitor service response:', response);
      return response.data || [];
    } catch (error: any) {
      console.error('Error in fetchVisitors thunk:', error);
      return rejectWithValue(error.message || 'Failed to fetch visitors');
    }
  }
);

export const fetchContactById = createAsyncThunk(
  'contacts/fetchContactById',
  async (contactId: string, { rejectWithValue }) => {
    try {
      console.log(`Fetching contact details for ID: ${contactId}`);
      const response = await customerService.getCustomerDetails(contactId);
      return response.data;
    } catch (error: any) {
      console.error(`Error fetching contact ${contactId}:`, error);
      const errorMessage = error.message || 'Failed to fetch contact details';
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchContactDetails = fetchContactById;

export const createContact = createAsyncThunk(
  'contacts/createContact',
  async (contactData: Partial<Contact>, { rejectWithValue }) => {
    try {
      const response = await customerService.createCustomer(contactData as any);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to create contact');
    }
  }
);

export const addContact = createContact;

interface UpdateContactPayload {
  contactId: string;
  data: Contact;
}

export const updateContact = createAsyncThunk<UpdateContactPayload, { contactId: string; data: Partial<Contact> }>(
  'contacts/updateContact',
  async ({ contactId, data }, { rejectWithValue }) => {
    try {
      const response = await customerService.updateCustomer(contactId, data);
      return { contactId, data: response.data as Contact };
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to update contact');
    }
  }
);

export const updateContactCompany = createAsyncThunk<UpdateContactPayload, { contactId: string; companyId: string | null }>(
  'contacts/updateContactCompany',
  async ({ contactId, companyId }, { rejectWithValue }) => {
    try {
      const response = await customerService.updateCustomer(contactId, { company: companyId });
      return { contactId, data: response.data as Contact };
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to update contact company');
    }
  }
);

export const deleteContact = createAsyncThunk(
  'contacts/deleteContact',
  async (contactId: string, { rejectWithValue }) => {
    try {
      await customerService.deleteContact(contactId);
      return contactId;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to delete contact');
    }
  }
);
